import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import style from './NewCustomPages.module.scss';
import defaultImage from '../../../assets/default.png';
import { saveUpdatedPageDetails, saveMetaDataUpdate } from "../../../actions/wizard";
import { WoodenFlooringDetails, floorLayingPattern } from './NewCustomPagesConstants';
import CivilWorkOptions from "../CivilWorkServices/CivilWorkOptions";

const WoodenFlooring = (props: any) => {
  const dispatch = useDispatch();
  const { isDrawingsExporting } = props;
  const pageDetails = useSelector((state: any) => state.wizard.pageDetails);
  const requiredMetaDataUpdate = useSelector((state: any) => state.wizard.requiredMetaDataUpdate);

  const latestStateRef = useRef(requiredMetaDataUpdate);

  const [updatedValues, setUpdatedValues] = useState(pageDetails);
  const [customPage, setCustomPage] = useState(false);

  useEffect(() => {
    setUpdatedValues(pageDetails);
    setCustomPage(pageDetails?.pageType === "created_page")
  }, [pageDetails]);

  // Update the meta details while unmounting.
  useEffect(() => {
    return () => {
      updateDetailsInMeta(false);
    }
  }, [])

  // Updating Item details in meta data
  const updateItems = (details: any) => {
    const updatedObj: any = {
      ...updatedValues,
      metaData: {
        ...updatedValues?.metaData,
        [details.id]: details.value
      }
    };
    setUpdatedValues(updatedObj)
    dispatch(saveMetaDataUpdate(updatedObj))
  }

  // Save function to save details in API
  const updateDetailsInMeta = (required: boolean) => {
    if (latestStateRef.current) {
      dispatch(saveUpdatedPageDetails(latestStateRef.current, required));
      dispatch(saveMetaDataUpdate(false))
    }
  }

  // Created a debounce to update the exiting quote details 
  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      updateDetailsInMeta(true);
    }, 4000); // Adjust the delay (in milliseconds) as needed

    latestStateRef.current = requiredMetaDataUpdate;

    return () => {
      clearTimeout(debounceTimer);
    };
  }, [requiredMetaDataUpdate]);

  return (
    <section className={style.new_page_container}>
      <h2 className="section_heading">Wooden Flooring Services</h2>
      <div className={style.wall_electrical_container}>
        <div className={`${style.canvas_container} ${style.flooring_specs_section}`}>
          {/* <div className={style.}> */}
          <div className={style.section_details_tab}>
            <h2 className="sub_tab_heading">FLOORING SPECIFICATION</h2>
            <div className={style.image_section}>
              <div className={style.floor_img_tab}>
                <h4>PATTERN IMAGE</h4>
                <div className={style.image_container}>
                  {customPage ? '' : <img crossOrigin="anonymous" alt="flooringImage" src={updatedValues?.floorTilesMetaData?.patternImageUrl ? `${updatedValues?.floorTilesMetaData?.patternImageUrl}?ver=${new Date().getTime()}` : defaultImage} width="100%" height="70px" />}
                </div>
              </div>
              <div className={style.floor_img_tab}>
                <h4>FLOOR IMAGE</h4>
                <div className={style.image_container}>
                  {customPage ? '' : <img crossOrigin="anonymous" alt="flooringImage" src={updatedValues?.floorTilesMetaData?.flooringImageUrl ? `${updatedValues?.floorTilesMetaData?.flooringImageUrl}?ver=${new Date().getTime()}` : defaultImage} width="100%" height="70px" />}
                </div>
              </div>
            </div>
          </div>
          {/* </div> */}
          <section>
            {
              !customPage && updatedValues?.elevationImage?.imageUrl ? <img crossOrigin="anonymous" src={`${updatedValues?.elevationImage?.imageUrl}?ver=${new Date().getTime()}`} alt="" className="image-view" /> :
                <div>
                  <p>Floor Plan with all wall dimensions, door / balcony dimensions</p>
                </div>
            }
          </section>
        </div>
        {!customPage ?
          <div className={style.flooring_sub_footer}>
            <div>
              <h4>FLOOR DETAILS</h4>
              {
                updatedValues?.floorTilesMetaData?.floorDetailsList?.map((floor, id) => (
                  Object.keys(floor)?.map((e, id) => {
                    if (['pattern', 'collection', 'brand', 'layingPattern', 'name'].includes(e)) {
                      return
                    }
                    return (
                      <div className={style.two_col_tab}>
                        <p>{e}</p>
                        <p>{floor[e] || '-'}</p>
                      </div>
                    )
                  })
                ))
              }
              <div>
              </div>
            </div>
            <div>
              <h4>FLOOR ACCESSORY DETAILS</h4>
              {
                updatedValues?.floorTilesMetaData?.floorAccessoryDetails && Object.entries(updatedValues?.floorTilesMetaData?.floorAccessoryDetails)?.map((e, id) => (
                  <div className={style.two_col_tab}>
                    <p>{e?.[0]}</p>
                    <p>{e?.[1] || '-'}</p>
                  </div>
                ))
              }
            </div>
            <div>
              <h4>FLOOR INSTALLATION</h4>
              {
                updatedValues?.floorTilesMetaData?.floorInstallationDetails && Object.entries(updatedValues?.floorTilesMetaData?.floorInstallationDetails)?.map((e, id) => (
                  <div className={style.two_col_tab}>
                    <p>{e?.[0]}</p>
                    <p>{e?.[1] || '-'}</p>
                  </div>
                ))
              }
              <div>
              </div>
            </div>
          </div>
          : ''}

        <div className={style.wall_electrical_modification}>
          <h2 className="sub_tab_heading">WOODEN FLOORING DETAILS</h2>
          <div className={style.summary_table}>
            <div className={`${style.five_col_tab}`}>
              <h4>Pattern</h4>
              <h4>Collection</h4>
              <h4>Product Name</h4>
              <h4>Brand</h4>
              <h4>Quantity (in qty)</h4>
            </div>
            {
              !customPage && updatedValues?.floorTilesMetaData?.floorDetailsList?.map((e, id) => (
                <div key={id} className={`${style.five_col_tab}`}>
                  <p>
                    {!isDrawingsExporting ? <select onChange={(v) => updateItems({ id: `${e?.productName?.split(' ')?.[0]}_${e?.layingPattern}_${id}`, value: v.target.value })}>
                      {
                        floorLayingPattern?.map((o) => <option value={o.value} selected={(updatedValues?.metaData?.[`${e?.productName?.split(' ')?.[0]}_${e?.layingPattern}_${id}`] || e?.layingPattern) === o.value}>{o.name}</option>)
                      }
                    </select> : <span>{updatedValues?.metaData?.[`${e?.productName?.split(' ')?.[0]}_${e?.layingPattern}_${id}`] || e?.layingPattern}</span>}
                  </p>
                  <p>{e?.collection}</p>
                  <p>{e?.productName}</p>
                  <p>{e?.brand}</p>
                  <p>{e?.numberOfBoxes}</p>
                </div>
              ))
            }
            <div className={`${style.five_col_tab}`}>
              {
                WoodenFlooringDetails?.map((e, i) => (
                  <p><CivilWorkOptions details={e} optionsList={e?.options} isDrawingsExporting={isDrawingsExporting} updateDetails={(e) => updateItems(e)} itemDetails={updatedValues?.metaData} type={e?.id !== 'pattern' ? "input" : ''} /></p>
                ))
              }
            </div>
          </div>
        </div>

      </div>
    </section>
  )
}

export default WoodenFlooring;